export type ZoneForPlacedAirHandlerRequirement = {
  type?: string | null;
  zoneItems: Array<{ structureItemId: string }>;
};

export function zoneRequiresPlacedAirHandler(
  zone: ZoneForPlacedAirHandlerRequirement,
  leftoverSpaceIds?: ReadonlySet<string>
): boolean {
  if (zone.type === 'ducted') return false;
  if (!leftoverSpaceIds || zone.zoneItems.length === 0) return true;
  return !zone.zoneItems.every((item) =>
    leftoverSpaceIds.has(item.structureItemId)
  );
}
